import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useParams } from "react-router-dom";
import Landing from "@/pages/Landing";
import Workbench from "@/pages/Workbench";
import CAWorkbench from "@/pages/CAWorkbench";
import Standards from "@/pages/Standards";
import Explained from "@/pages/Explained";
import Enforcement from "@/pages/Enforcement";
import LiveEngine from "@/pages/LiveEngine";
import Receipt from "@/pages/Receipt";
import Diagnostics from "@/pages/Diagnostics";

function App() {
    return (
        <div className="App">
            <ErrorBoundary>
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<Landing />} />
                        <Route path="/request/:eventId" element={<RequestRouter />} />
                        <Route path="/standards" element={<Standards />} />
                        <Route path="/explained" element={<Explained />} />
                        <Route path="/enforcement" element={<Enforcement />} />
                        <Route path="/live" element={<LiveEngine />} />
                        <Route path="/r/:hash" element={<Receipt />} />
                        <Route
                            path="/receipt/:hash"
                            element={<ReceiptRedirect />}
                        />
                        <Route path="/diagnostics" element={<Diagnostics />} />
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                </BrowserRouter>
            </ErrorBoundary>
        </div>
    );
}

class ErrorBoundary extends React.Component {
    state = { hasError: false };
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    render() {
        if (this.state.hasError) {
            return (
                <div className="flex min-h-screen items-center justify-center bg-slate-50 px-6">
                    <div
                        className="max-w-md rounded-sm border border-slate-200 bg-white p-8"
                        data-testid="app-error-boundary"
                    >
                        <h1 className="text-lg font-medium text-slate-900">
                            Scenario could not be loaded
                        </h1>
                        <p className="mt-2 text-sm leading-relaxed text-slate-600">
                            Please return to the workbench or retry.
                        </p>
                        <div className="mt-5 flex items-center gap-3">
                            <button
                                onClick={() => window.location.reload()}
                                data-testid="app-error-retry-btn"
                                className="rounded-sm bg-blue-950 px-4 py-2 text-sm font-medium text-white hover:bg-blue-900"
                            >
                                Retry
                            </button>
                            <a
                                href="/"
                                data-testid="app-error-home-link"
                                className="text-sm text-blue-950 underline"
                            >
                                Return to overview
                            </a>
                        </div>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}

function RequestRouter() {
    const { eventId } = useParams();
    return eventId.startsWith("CA-") ? <CAWorkbench /> : <Workbench />;
}

function ReceiptRedirect() {
    const hash = window.location.pathname.split("/").pop();
    return <Navigate to={`/r/${hash}`} replace />;
}

export default App;
